import * as React from 'react';
import { ICategoryTreeItem } from '../../../interfaces';

interface ICategoryNavigationItemProp {
    item: ICategoryTreeItem;

    onSelect(item: ICategoryTreeItem): void;
}

const CategoryNavigationSubItem: React.FunctionComponent<ICategoryNavigationItemProp> = props => {
    const { item, onSelect } = props;

    const clickHandler = () => onSelect(item);

    return (
        <li className={`navigation-section__navigation-content-children-item`} onClick={clickHandler}>
            {item.name}
        </li>
    );
};

export default CategoryNavigationSubItem;
